import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  getTags: (filters?: any[]) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $filters: [Filter]
        ) {
          listTag(
            limit: 999
            filters: $filters
          ) {
            items {
              id
              title {
                ru
                current
              }
              group {
                alias
                id
              }
              parent {
                id
              }
            }
          }
        }
      `,

      variables: {
        filters,
      },
    }),
  ),
})
